/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Search_PlaceholderInputs */

const en_ticket_search_placeholder = /** @type {(inputs: Ticket_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search tickets...`)
};

const ja_ticket_search_placeholder = /** @type {(inputs: Ticket_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケットを検索...`)
};

const fr_ticket_search_placeholder = /** @type {(inputs: Ticket_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des tickets...`)
};

const de_ticket_search_placeholder = /** @type {(inputs: Ticket_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets suchen...`)
};

/**
* | output |
* | --- |
* | "Search tickets..." |
*
* @param {Ticket_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_search_placeholder = /** @type {((inputs?: Ticket_Search_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Search_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_search_placeholder(inputs)
	if (locale === "ja") return ja_ticket_search_placeholder(inputs)
	if (locale === "fr") return fr_ticket_search_placeholder(inputs)
	return de_ticket_search_placeholder(inputs)
});